import script from "./StaticAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticAlert.vue?vue&type=script&setup=true&lang=js"

import "./StaticAlert.vue?vue&type=style&index=0&id=0fa9f4b2&lang=scss&scoped=true"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa9f4b2"]])

export default __exports__